export default __webpack_public_path__ + "static/media/custom-paket-en.5d6c71ce.png";